import { COMPLAIN_CHANGE_VISIBILITY, IComplainChangeVisibility } from '../../constants/actionTypes/complain';

export const changeVisibility = (offerId: number) => (isVisible: boolean): IComplainChangeVisibility => ({
  offerId,
  isVisible,
  type: COMPLAIN_CHANGE_VISIBILITY,
});
